import React, { PureComponent } from 'react';

const withDocumentTitle = title => WrappedComponent =>
  class extends PureComponent {
    componentDidMount() {
      const defaultTitle = 'Carvana® Purchase';
      if (document) {
        document.title = title ? `${title} | ${defaultTitle}` : defaultTitle;
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  };

export default withDocumentTitle;
